"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-use-before-define */
var EventQueue = function () {
    var queue = [];
    return {
        getEventsQueue: getEventsQueue,
        getLength: getLength,
        isEmpty: isEmpty,
        pushEvent: pushEvent,
        pushEvents: pushEvents,
        popEvent: popEvent,
        popEvents: popEvents,
    };
    function getEventsQueue() {
        return queue;
    }
    function getLength() {
        return queue.length;
    }
    function isEmpty() {
        return queue.length === 0;
    }
    function pushEvent(eventObject) {
        queue.push(eventObject);
    }
    function pushEvents(events) {
        queue = queue.concat(events);
    }
    function popEvent() {
        return queue.shift();
    }
    function popEvents() {
        var allData = queue;
        queue = [];
        return allData;
    }
};
exports.default = EventQueue;
//# sourceMappingURL=EventQueue.js.map